module.exports = __webpack_public_path__ + "img/feature-mobile.032e16a3.webp";